import { render } from "./Satzung.vue?vue&type=template&id=438d2132&scoped=true"
import script from "./Satzung.vue?vue&type=script&lang=js"
export * from "./Satzung.vue?vue&type=script&lang=js"

import "./Satzung.vue?vue&type=style&index=0&id=438d2132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438d2132"]])

export default __exports__